export default "/images/framework/WordMissionEng.0df93c19.svg?0df93c19";